import { FunctionComponent } from 'react';

import { DynamicPdfComponentName, DynamicPdfComponentProps } from '@breathelife/types';

import { Questionnaire } from '../../QuestionnaireVariants/QuestionnaireVariantsB/Questionnaire';
import { CarrierInformation } from './CarrierInformation';
import { CryptoSignature } from './CryptoSignature';
import { InsuranceFirmInformation } from './InsuranceFirmInformation';
import { OwnerInformation } from './OwnerInformation';
import { PayorInformation } from './PayorInformation';
import { PdfTitle } from './PdfTitle';
import { ProductInformation } from './ProductInformation';
import { ProposedInsuredInformation } from './ProposedInsuredInformation';
import { SubmissionDate } from './SubmissionDate';

const ComponentListB: { [key in DynamicPdfComponentName]?: FunctionComponent<DynamicPdfComponentProps> } = {
  ProductInformation: ProductInformation,
  ProposedInsuredInformation: ProposedInsuredInformation,
  OwnerInformation: OwnerInformation,
  PayorInformation: PayorInformation,
  PdfTitle: PdfTitle,
  CryptoSignature: CryptoSignature,
  Questionnaire: Questionnaire,
  SubmissionDate: SubmissionDate,
  InsuranceFirmInformation: InsuranceFirmInformation,
  CarrierInformation: CarrierInformation,
};

export default ComponentListB;
